export default "../assets/images/ups_logo.svg";